import React, { Component } from "react";
//import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import { LOGIN_TYPE_ADMIN, ClientsAnalysis, Dashboard_API_Hit_Report, Dashboard_Mobile_App, Dashboard_Api_hit_counts, Months, SERVICE42_TEXT } from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
//import Parser from 'html-react-parser';
//import { Link } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import Select2 from 'react-select2-wrapper';
import $ from "jquery";
import 'react-select2-wrapper/css/select2.css';
//import 'react-select2-wrapper/css/select2.css';
//import { Alert } from 'rsuite';
import { Chart } from "react-google-charts";

import Header from "./include/Header";



class Dashboard extends Component {
  constructor(props) {
    let year = new Date().getFullYear();
    let crMonth = new Date().getMonth() + 1;
    super(props);
    this.state = {
      totalClients: '--',
      totalClientsInfo: { 'Prepaid': '--', 'Postpaid': '--', 'TokenStatusActive': '--' },
      tokenActive: '--',
      tokenInActive: '--',
      tokenExpireUserInfo: [],
      loginActiveStatus: '--',
      loginInactiveStatus: '--',
      loginInactiveUserInfo: [],
      balanceExhausted: '--',
      balanceExhaustedUserInfo: [],
      tokenWillBeExpireDays: '--',
      tokenWillBeExpireUserInfo: [],
      clientist: [{ text: 'All Client', id: -1, value: 'all client' }],
      lastSixMont: [],
      currentMonth: '',
      selectedClient: '',

      //using API Hits Reports
      totalHits:'--',
      totalOtherHits: '--',
      fileupload:[],
      rcHits:[],
      challanHits:[],
      freeRcHits:[],
      mobileVehicleHits: [],
      serviceHistoryHits: [],
      usedCarPricingHits: [],
      usedCarPricingV2Hits:[],
      mmvHits:[],

      mobileApplication: { 'TotalLeads': '--', 'apiTypes': [] },

      leadReport: [],
      MobileAppStartDate: '',
      MobileAppEndDate: '',
      APIHitsStartDate: '',
      APIHitsEndDate: '',
      DataNotFound: "Data Not Found",
      TokenExpireDaysForHtml: '',
      IsShowTokenExpireDaysForHtml: false,
      selectUser: 'all client',
      selectApitype: 'all',
      selectPersonalApitype: 'all',

      //using RTO Mobile Application Analysis
      challanApiHitInfo: { 'total': '--', 'suc_owndb': '--', 'notfound_gama': '--', 'fail': '--', 'timeout': '--' },
      rcPrimeHitInfo: { 'rc_success': '--', 'rc_failure': '--', 'rc_total': '--' },
      serviceHitInfo: { 'service_success': '--', 'service_failure': '--', 'service_total': '--' },
      totalHitInfo: { 'total_success': '--', 'total_failure': '--', 'total_hits': '--' },
      userHitInfo: { 'total_users': '--', 'new_registered_user': '--', 'logged_users': '--' },
      
      apiHitReportLoading: false,
      backDate: '',
      apiHitReportShow: false,
      docInfoSelectClient: 'all client',
      docInfoStartDate: '',
      docInfoEndDate: '',
      docInfoSecShow: false,
      docInfoData: {},
      appInfoSecShow: false,
      graphFilters:{year:year, type:'daily', month:crMonth, monthQut:'1_3', clientType:'all client', graphData:[]}
    }
  }

  componentDidMount() {
    let date_ob = new Date();
    let date = ("0" + (date_ob.getDate())).slice(-2);
    let month1 = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    var startDate = year + "-" + month1 + "-" + date;
    var enddate = year + "-" + month1 + "-" + date;
    date_ob.setDate(date_ob.getDate() - 31);
    this.setState({
      MobileAppStartDate: startDate,
      MobileAppEndDate: enddate,
      APIHitsStartDate: startDate,
      APIHitsEndDate: enddate,
      backDate: '2023-11-01', //date_ob.toISOString().slice(0, 10)
      docInfoStartDate: startDate,//date_ob.toISOString().slice(0, 10),
      docInfoEndDate: enddate
    });
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      this.loadClientAnalysisData();
      //this.filterMobileReport(startDate, enddate);
      //this.filterAPIHitReport(startDate, enddate,'all','all client')
      this.filterGraph();
    }
    if(reactLocalStorage.get("is_have_dashboard_service") === SERVICE42_TEXT) {
      this.loadClientAnalysisData();
      this.filterGraph();
    }
  }
  loadClientAnalysisData() {
    Apihelpers.getdataresponse(ClientsAnalysis).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data', res.data.data);
        let getData = res.data.data[0];
        let clientist = [{ text: 'All Client', id: -1, value: 'all client' }];
        res.data.data[0].api_hit_users.map((item, i) => {
          clientist.push({ text: item.text, id: item.key, value: item.id, })
        })
        //console.log('clientist', clientist);
        this.setState({
          totalClients: getData.TotalClients,
          totalClientsInfo: { 'Prepaid': getData.TotalClientsInfo.Prepaid, 'Postpaid': getData.TotalClientsInfo.Postpaid, 'TokenStatusActive': getData.TotalClientsInfo.TokenStatusActive },
          tokenActive: getData.TokenActive,
          tokenInActive: getData.TokenExpireUserInfo.length,
          tokenExpireUserInfo: getData.TokenExpireUserInfo,
          loginActiveStatus: getData.loginActiveStatus,
          loginInactiveStatus: getData.loginInactiveStatus,
          loginInactiveUserInfo: getData.loginInactiveUserInfo,
          balanceExhausted: getData.BalanceExhausted,
          balanceExhaustedUserInfo: getData.BalanceExhaustedUserInfo,
          tokenWillBeExpireDays: getData.TokenWillBeExpireDays,
          tokenWillBeExpireUserInfo: getData.TokenWillBeExpireUserInfo,
          clientist: clientist,
          TokenExpireDaysForHtml: getData.TokenExpireDaysForHtml
        });

        if (getData.TokenWillBeExpireDays > 0) {
          this.setState({ IsShowTokenExpireDaysForHtml: true });
        }
        //this.filterHitReport();
      } else {
        console.log('res.data', res.data);
      }
    });
  }

  filterHitReport = () => {
    var startDate = this.state.APIHitsStartDate;
    var endDate = this.state.APIHitsEndDate;
    let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    this.state.apiHitReportLoading = true;
    var selectClient = $("#selectClient").val();
    //var selectMonth = $("#selectMonth").val();
    var apitype = $("#selectApi").val();
    if (apitype === null || apitype === '' || apitype === 'all') {
      apitype = 'all';
    }
    if (selectClient == null || selectClient == 'all client') {
      selectClient = '-1';
    }

    if (dayDiff <= 31) {
      this.filterAPIHitReport(startDate, endDate, apitype, selectClient);
    } else {
      alert('Please select date range maximum 31 days');
    }
  }

  filterAPIHitReport(startDate, endDate, apitype, selectClient) {
    $(".loader").show();
    let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, 'apitype': apitype };
    //console.log('inputData', inputData);
    Apihelpers.postdataresponse(Dashboard_API_Hit_Report, inputData).then(res => {
      if (res.data.status === true) {
        console.log('res.data.data', res.data.data);
        let resData = res.data.data;
        this.setState({
          totalHits:resData.totalHits,
          totalOtherHits:resData.totalOtherHits,
          fileupload:resData.uploadFile,
          rcHits:resData.rc,
          challanHits:resData.challan,
          freeRcHits:resData.freeRC,
          mobileVehicleHits: resData.mobileVehicleHits,
          serviceHistoryHits: resData.serviceHistory,
          usedCarPricingHits: resData.usedCarPricing,
          usedCarPricingV2Hits: resData.usedCarPricingV2,
          mmvHits: resData.mmvHits
        });
      } else {
        console.log('res.data', res.data);
        this.setState({
          totalHits:'--',
          totalOtherHits:'--',
          fileupload:[],
          rcHits:[],
          challanHits:[],
          freeRcHits:[],
          mobileVehicleHits: [],
          serviceHistoryHits: [],
          usedCarPricingHits: [],
          usedCarPricingV2Hits: [],
          mmvHits: []
        });
      }
      $(".loader").hide();
      this.state.apiHitReportLoading = false;
    });
  }

  apiHitInfoSecOpen = () => {
    if(this.state.apiHitReportShow) {
      this.setState({apiHitReportShow:false})
    } else {
      this.setState({apiHitReportShow:true});
      this.filterHitReport()
    }
  }

  filterMobileApp = () => {
    var startDate = this.state.MobileAppStartDate;
    var endDate = this.state.MobileAppEndDate;
    let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
    dayDiff = dayDiff / (1000 * 60 * 60 * 24);
    //console.log('dayDiff',dayDiff);
    if (dayDiff <= 31) {
      this.filterMobileReport(startDate, endDate);
    } else {
      alert('Please select date range maximum 31 days');
    }
  }
  filterMobileReport = (startDate, endDate) => {
    $(".loader").show();
    let inputData = { 'startDate': startDate, 'endDate': endDate };
    //console.log('inputData', inputData);
    Apihelpers.postdataresponse(Dashboard_Mobile_App, inputData).then(res => {
      if (res.data.status === true) {
        console.log('mobile-app: res.data.data', res.data.data);
        let resData = res.data.data;
        console.log(resData);
        var reports = resData["LeadReportInfo"];

        this.setState({
          mobileApplication: { 'TotalLeads': resData["Total Lead"] },
          leadReport: reports
        });

        // user hits
        var totalUserHits = resData["total_users"];
        var newRegisterUser = resData["new_register_user"];
        var loggedUsers = resData["logged_users"];
        this.setState({
          userHitInfo: { 'total_users': totalUserHits, 'new_registered_user': newRegisterUser, 'logged_users': loggedUsers },
        });
        // total hits of prime and service history
        var totalApiHits = resData["totalApiHits"];
        var totalSuccesHits = resData["totalSuccesHits"];
        var totalFilureHits = resData["totalFilureHits"];
        console.log('total_success', totalSuccesHits, 'total_failure', totalFilureHits, 'total_hits', totalApiHits)
        this.setState({
          totalHitInfo: { 'total_success': totalSuccesHits, 'total_failure': totalFilureHits, 'total_hits': totalApiHits },
        })

        //service history hits
        var serviceTotal = resData["serviceTotal"];
        var serviceSuccess = resData["serviceSuccess"];
        var serviceFailure = resData["serviceFailure"];
        console.log('service_success', serviceSuccess, 'service_failure', serviceFailure, 'service_total', serviceTotal)
        this.setState({
          serviceHitInfo: { 'service_success': serviceSuccess, 'service_failure': serviceFailure, 'service_total': serviceTotal },
        })

        //prime hits
        var rcTotal = resData["prime_total"];
        var rcSuccess = resData["prime_success"];
        var rcFailure = resData["prime_failure"];
        console.log("rc_total", rcTotal, "rc_sucess", rcSuccess, "rc_failure", rcFailure)
        this.setState({
          rcPrimeHitInfo: { 'rc_success': rcSuccess, 'rc_failure': rcFailure, 'rc_total': rcTotal, }
        });

        //challan hits
        var total = resData["challan_total"];
        var compOwnDb = resData["challan_database"];
        var gamaNot = resData["challa_gamma_not_found"];
        var fail = resData["challa_failure"];
        var timeOut = resData["challan_timeout"];
        this.setState({
          challanApiHitInfo: { 'total': total, 'suc_owndb': compOwnDb, 'notfound_gama': gamaNot, 'fail': fail, 'timeout': timeOut }
        });
        if (this.state.apiHitReportLoading === false) {
          $(".loader").hide();
        }
      } else {
        console.log('res.data', res.data);
      }
    });
  }
  loadMore = (e, sourcetype) => {
    let tr = $(e.target).parents('.next-child');
    if (tr.hasClass('open')) {
      tr.removeClass('open');
    } else {
      var startDate = this.state.APIHitsStartDate;
      var endDate = this.state.APIHitsEndDate;
      let dayDiff = Math.abs(new Date(endDate) - new Date(startDate));
      dayDiff = dayDiff / (1000 * 60 * 60 * 24);
      this.state.apiHitReportLoading = true;
      var selectClient = $("#selectClient").val();
      var apitype = $("#selectApi").val();
      if (apitype === null || apitype === '' || apitype === 'all') {
        apitype = 'all';
      }
      if (selectClient == null || selectClient == 'all client') {
        selectClient = '-1';
      }
      $(".loader").show();
      let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, 'apitype': apitype, 'apiTypeSource': sourcetype };
      Apihelpers.postdataresponse('Dashboard/hit_reports_for_timeout_and_failure', inputData).then(res => {
        if (res.data.status === true) {
          console.log('res.data.data', res.data.data);
          let data = res.data.data;
          tr.next('tr').find('table td').eq(0).text('All Hits: ' + data.allHits);
          tr.next('tr').find('table td').eq(1).text('Not Found: ' + data.failure);
          tr.next('tr').find('table td').eq(2).text('Time Out: ' + data.timeOut);
        } else {
          alert('Please Check Your Plan Type....');
        }
        $(".loader").hide();
      });
      $('.next-child').removeClass('open');
      tr.addClass('open');
    }
    //console.log('tr',tr);
  }
  filterDocumentInfo = () => {
    let startDate = this.state.docInfoStartDate;
    let endDate = this.state.docInfoEndDate;
    let selectClient = this.state.docInfoSelectClient;
    let api_type = this.state.selectPersonalApitype;
    if (selectClient == null || selectClient == 'all client') {
      selectClient = '-1';
    }
    $(".loader").show();
    let inputData = { 'selectedClient': selectClient, 'startDate': startDate, 'endDate': endDate, "apitype": api_type };
    Apihelpers.postdataresponse('Dashboard/reports-for-personalnfoapihit', inputData).then(res => {
      if (res.data.status === true) {
        //console.log('res.data.data',res.data.data);
        this.setState({ docInfoData: res.data.data });
        $(".loader").hide();
      } else {
        console.log('res.data', res.data);
        this.setState({ docInfoData: {} });
      }
    })
  }
  showDocInfoSec = () => {
    if (this.state.docInfoSecShow) {
      this.setState({
        docInfoSecShow: false
      });
    } else {
      this.filterDocumentInfo();
      this.setState({
        docInfoSecShow: true
      });
    }
  }
  printVal = (val) => {
    return (val === undefined || val === "") ? '--' : val;
  }

  showAppInfoSec = () => {
    if (this.state.appInfoSecShow) {
      this.setState({
        appInfoSecShow: false
      });
    } else {
      this.filterMobileApp();
      this.setState({
        appInfoSecShow: true
      });
    }
  }

  
  filterGraph = () => {
    let parms = '?year='+this.state.graphFilters.year+'&type='+this.state.graphFilters.type+'&clientType='+this.state.graphFilters.clientType+'&month='+this.state.graphFilters.month+'&monthQut='+this.state.graphFilters.monthQut;
    $(".loader").show();
    Apihelpers.getdataresponse(Dashboard_Api_hit_counts+parms).then((res)=>{
      if(res.data.status === true) {
        let data = res.data.data;
        console.log('data',data);
        let dataArray = [];
        if (this.state.graphFilters.type === 'monthly') {
          let monthQut = this.state.graphFilters.monthQut.split('_');
          if (this.state.graphFilters.clientType === 'topTen') {
            data[0].forEach((aa,i)=>{
              if (i === 0) {return};
              let clName = this.state.clientist.filter((cl)=>(cl.value == aa));
              if(clName.length > 0) {
                data[0][i] = clName[0].text;
              }
            });
            
            if(data[0].length === 1) {
              alert('data is not available...');
            } else {
              dataArray = data;
            }
          } else {
            dataArray = [['Month', 'Counts']];
            Months.forEach((m,i)=>{
              if ((i+2) > monthQut[0] && i < monthQut[1]) {
                let array = data.filter((obj)=> (obj._id == (i+1)) );
                if(array.length > 0) {
                  dataArray.push([m, array[0].count]);
                } else {
                  dataArray.push([m, 0]);
                }
              }
            });
          }
        } else if (this.state.graphFilters.type === 'daily') {
          // let days = new Date(this.state.graphFilters.year, this.state.graphFilters.month, 0).getDate();
          // dataArray = [['Daily', 'Counts']];
          // for(let i = 1; i <= days; i++) {
          //   let array = data.filter((obj) => obj._id.date == (i) );
          //   if(array.length > 0) {
          //     dataArray.push([i.toString(), array[0].count]);
          //   } else {
          //     dataArray.push([i.toString(), 0]);
          //   }
          // }
          if (this.state.graphFilters.clientType === 'topTen') {
            let newarray = [data[0]];
            data.forEach((aa,i)=>{
              if (i === 0) {return};
              data[i][0] = data[i][0].toString();

              let crmm = new Date().getMonth()+1;
              if(aa[0] > new Date().getDate() && crmm == this.state.graphFilters.month) {
                console.log('data is next days with 0 value',aa);
              } else {
                newarray.push(aa);
              }
            });
            newarray[0].forEach((aa,i)=>{
              if (i === 0) {return};
              let clName = this.state.clientist.filter((cl)=>(cl.value == aa));
              if(clName.length > 0) {
                newarray[0][i] = clName[0].text;
              }
            });
            
            if(newarray[0].length === 1) {
              alert('data is not available...');
            } else {
              dataArray = newarray;
            }
          } else {
            dataArray = [['Daily', 'Counts']];
            data.forEach((aa)=>{
              let crmm = new Date().getMonth()+1;
              if(aa[0] > new Date().getDate() && aa[1] === 0 && crmm == this.state.graphFilters.month ) {
                console.log('data is next days with 0 value',aa);
              } else {
                let newAa = aa;
                newAa[0] = newAa[0].toString();
                dataArray.push(newAa);
              }
            });
          }
          
        }
        console.log('dataArray',dataArray);
        this.setState({
          graphFilters: {...this.state.graphFilters, 'graphData': dataArray}
        })
        $(".loader").hide();
      }
    })
  }

  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN || reactLocalStorage.get("is_have_dashboard_service") === SERVICE42_TEXT) {
      let crYear = new Date().getFullYear();
      return (
        <React.Fragment>
          <div className="wrapper dashboardPage">
            <Header />
            <div className="container">
              {
                //JSON.stringify(this.state.clientist, null,2)
              }
              <div className="infoTabe clientInfoSec">
                <div className="clientInfoNew">
                  <h4 className="title"><strong>Clients</strong> Summary and Analysis </h4>
                  <div className="tileRow eleScorll">
                    <div className="tile">
                      <div className="aa">Total:</div>
                      <div className="bb">{this.state.totalClients}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"><a href="./client-list">View List</a> </div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Login Active</div>
                      <div className="bb">{this.state.loginActiveStatus}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"> <a href="./client-list?loginStatus=login-active">View List</a> </div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Login InActive:</div>
                      <div className="bb">{this.state.loginInactiveStatus}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"> <a href="./client-list?loginStatus=login-inactive">View List</a></div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Token Active:</div>
                      <div className="bb">{this.state.tokenActive}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"> <a href="./client-list?loginStatus=all&tokenStatus=token-active">View List</a> </div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Token InActive:</div>
                      <div className="bb">{this.state.tokenInActive}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"> <a href="./client-list?loginStatus=all&tokenStatus=token-inactive">View List</a> </div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Balance Exhausted:</div>
                      <div className="bb">{this.state.balanceExhausted}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"> <a href="./client-list?loginStatus=all&tokenStatus=balance-exhausted">View List</a> </div> : ''
                      }
                    </div>
                    <div className="tile">
                      <div className="aa">Token Will be Expire:</div>
                      <div className="bb">{this.state.tokenWillBeExpireDays}</div>
                      {
                        (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) ? <div className="cc"><a href="./client-list?loginStatus=all&tokenStatus=token-expire">View List</a></div> : ''
                      }
                    </div>
                  </div>
                </div>
                
                <div className="graphBlock">
                    {
                      //JSON.stringify(this.state.graphFilters,null,2)
                    }
                  <div className="blockFilter form">
                    <div className="row">
                      <div className="col"></div>
                      <div className="col-md-2">
                        <select className="form-control" onChange={
                          (e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'type':e.target.value}
                            })
                          } 
                        } defaultValue={this.state.graphFilters.type}>
                          <option value="monthly">Monthly</option>
                          {/* <option value="weekly">Weekly</option> */}
                          <option value="daily">Daily</option>
                        </select>
                      </div>
                      <div className="col-md-2">
                        <select className="form-control" onChange={
                          (e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'year':e.target.value}
                            })
                          }
                        } defaultValue={this.state.graphFilters.year}>
                          <option value={crYear}>{crYear}</option>
                          <option value={crYear-1}>{crYear-1}</option>
                          <option value={crYear-2}>{crYear-2}</option>
                          <option value={crYear-3}>{crYear-3}</option>
                        </select>
                      </div>
                      {
                        (this.state.graphFilters.type === 'daily') ?
                        <div className="col-md-2">
                          <select className="form-control" onChange={
                            (e) => {
                              this.setState({
                                graphFilters: {...this.state.graphFilters, 'month':e.target.value}
                              })
                            }
                          } value={this.state.graphFilters.month}>
                            {
                              Months.map((it,i)=>{
                                return (<option key={i} value={i+1}>{it}</option>)
                              })
                            }
                          </select>
                        </div>
                      :
                        <div className="col-md-2">
                          <select className="form-control" onChange={(e)=>{
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'monthQut':e.target.value}
                            })
                          }} 
                          value={this.state.graphFilters.monthQut}>
                            <option value="1_3">January to March</option>
                            <option value="4_6">April to June</option>
                            <option value="7_9">July to September</option>
                            <option value="10_12">October to December</option>
                          </select>
                        </div>
                      }
                      <div className="col-md-2">
                        <Select2
                          data={[{ "text": "Every Client", "value": "topTen" }, ...this.state.clientist]}
                          options={{
                            placeholder: 'select client',
                          }}
                          className="form-control"
                          value={this.state.graphFilters.clientType}
                          onChange={(e) => {
                            this.setState({
                              graphFilters: {...this.state.graphFilters, 'clientType':e.target.value}
                            })
                          }}
                        />
                      </div>
                      <div className="col-md-auto">
                        <button className="blueBtn" type="button" onClick={this.filterGraph}>Filter</button>
                      </div>
                      <div className="col"></div>
                    </div>
                  </div>
                  {
                    this.state.graphFilters.graphData.length > 0 ?
                    <Chart
                    chartType="LineChart"
                    width="100%"
                    height="400px"
                    data={this.state.graphFilters.graphData}
                    options={{
                      //title: 'Company Performance',
                      //curveType: 'function',
                      //hAxis: { title: "Date" },
                      vAxis: { title: "API Hit Counts"},
                      legend: { position: 'top' },
                      lineWidth: 3,
                      'chartArea': { left: 100, top: 70, 'width': '90%', 'height': '70%' },
                    }}
                  />
                  :
                  <div style={{'textAlign':'center', 'padding':'15px', 'color':'gray'}}>Data is not available</div>
                  }
                  
                </div>
              </div>

              <div className="infoTabe apiHitInfo">
                <h4 className="headBg">
                  API Hits Reports <span className="arrow" onClick={this.apiHitInfoSecOpen}><i className="fa fa-chevron-circle-down"></i></span>
                </h4>
                <div style={this.state.apiHitReportShow ? {} : {'display':'none'}}>
                  <div className="blockFilter form">
                    <div className="row">
                      <div className="col-md">
                        <div className="form-group">
                          <label className="control-title">Select Client</label>
                          <Select2
                            data={this.state.clientist}
                            options={{
                              placeholder: 'select client',
                            }}
                            id="selectClient"
                            className="form-control"
                            value={this.state.selectUser}
                            onChange={(e) => this.setState({ selectUser: e.target.value })}
                          />
                        </div>
                      </div>
                      <div className="col-md">
                        <div className="form-group">
                          <label className="control-title">Select Plan Type</label>
                          {/* <Select2
                                    data = {[{text:'All',value:'all'}, {text:'RCPrime',value:'9'}, {text:'RCExcel',value:'10'}]}
                                    options={{
                                    placeholder: 'select api',
                                    }}
                                    id="selectApi"
                                    className="form-control"
                                    value={this.state.  }
                                    onChange={(e) => this.setState({ selectApitype: e.target.value })}
                                /> */}
                          <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectApitype: e.target.value })}>
                            <option value="all">All</option>
                            <option value="9">RCPrime</option>
                            <option value="10">RCExcel</option>
                            <option value="2">Challan</option>
                            <option value="36">ChallanExcel</option>
                            <option value="15">RCPrimeReverse</option>
                            <option value="3">Service History</option>
                            <option value="14">Used Car Pricing</option>
                            <option value="0">Free RC</option>
                            <option value="16">RCPrimeReverseBasic</option>
                            <option value="19">Used Car Pricing v2</option>
                            <option value="32">comboPrime</option>
                            <option value="33">comboChallan</option>
                            <option value="37">Mobile Vehicle</option>
                            <option value="38">comboMobileVehicle</option>
                            <option value="25">MMV</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md">
                        <div className="form-group">
                          <label className="control-title">Select Start Range</label>
                          <input className="form-control" min={this.state.backDate} id="startDate" value={this.state.APIHitsStartDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ APIHitsStartDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-md">
                        <div className="form-group">
                          <label className="control-title">Select End Range</label>
                          <input className="form-control" min={this.state.backDate} id="endDate" value={this.state.APIHitsEndDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ APIHitsEndDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <button onClick={this.filterHitReport} className="blueBtn">Filter</button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <ul>
                        <li>
                          <div className="key">Total API Hits</div>
                          <div className="val">{this.state.totalHits}</div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-4">
                      <ul>
                        <li>
                          <div className="key">Total Other Hits</div>
                          <div className="val">{this.state.totalOtherHits}</div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-4">
                      <ul>
                        <li>
                          <div className="key">Bulk Upload Files</div>
                          <div className="val">
                            {
                              (this.state.fileupload.length > 0) ?
                              <div>
                                {(this.state.fileupload[0].rcExcel + this.state.fileupload[0].challanExcel + this.state.fileupload[0].mobileExcel)}
                                <div className="toolTip">
                                  <i className="infoIcon" style={{'verticalAlign':'top'}}></i>
                                  <div className="toolTipText">
                                    RC Excel: {this.state.fileupload[0].rcExcel}<br />
                                    Challan Excel: {this.state.fileupload[0].challanExcel}<br />
                                    Mobile Excel: {this.state.fileupload[0].mobileExcel}<br />
                                  </div>
                                </div>
                              </div>
                              : '--'
                            }
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="dasInfoTable">
                    <div>
                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>
                            <div>RC <span style={{'color':'#165fbf'}}>{this.state.rcHits[0]?.data.total}</span> &nbsp; 
                              <div className="toolTip rightAlin">
                                <i className="infoIcon"></i>
                                <div className="toolTipText">
                                  Total (RCPrime,RCExcel, RCPrimeReverse, RCPrimeReverseBasic, comboMobileVehicle & comboPrime) Hits
                                </div>
                              </div>
                            </div> 
                          </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Incomplete</th>
                          <th style={{'width':'200px'}}>Not Found</th>  
                          <th>Time Out</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.rcHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.incomplete}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'database' || 
                              rowObj.sourceType === 'alpha' || 
                              rowObj.sourceType === 'beta' || 
                              rowObj.sourceType === 'gamma' || 
                              rowObj.sourceType === 'delta' || 
                              rowObj.sourceType === 'deltav2' || 
                              rowObj.sourceType === 'deltacache' || 
                              rowObj.sourceType === 'theta') {
                              if(rowObj.data.success === 0 && rowObj.data.incomplete === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.incomplete}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>
                    
                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>
                            <div>Challan <span style={{'color':'#165fbf'}}>{this.state.challanHits[0]?.data.total}</span> &nbsp; 
                              <div className="toolTip rightAlin">
                                <i className="infoIcon"></i>
                                <div className="toolTipText">
                                  Total (Challan,ChallanExcel & comboChallan) Hits
                                </div>
                              </div>
                            </div> 
                          </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Not Found</th>
                          <th style={{'width':'200px'}}>Failure</th>  
                          <th>Time Out</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          this.state.challanHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.notfound}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'database' || 
                              rowObj.sourceType === 'gamma' || 
                              rowObj.sourceType === 'delta' || 
                              rowObj.sourceType === 'deltaPro' || 
                              rowObj.sourceType === 'zeta') {
                              if(rowObj.data.success === 0 && rowObj.data.notfound === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.notfound}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>Mobile Number <span style={{'color':'#165fbf'}}>{this.state.mobileVehicleHits[0]?.data.total}</span>  </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          this.state.mobileVehicleHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'database' || 
                              rowObj.sourceType === 'delta') {
                              if(rowObj.data.success === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td> &nbsp; </td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>
                    
                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>Used Car Pricing <span style={{'color':'#165fbf'}}>{this.state.usedCarPricingHits[0]?.data.total}</span></th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          this.state.usedCarPricingHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'usedCarPricing') {
                              if(rowObj.data.success === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>
                          Used Car Pricing V2  <span style={{'color':'#165fbf'}}>{this.state.usedCarPricingV2Hits[0]?.data.total}</span>
                          </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          this.state.usedCarPricingV2Hits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'usedCarPricingV2') {
                              if(rowObj.data.success === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}> Service History <span style={{'color':'#165fbf'}}>{this.state.serviceHistoryHits[0]?.data.total}</span> </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.serviceHistoryHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">All Source</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}> Free RC  <span style={{'color':'#165fbf'}}>{this.state.freeRcHits[0]?.data.total}</span></th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.freeRcHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'freesource') {
                              if(rowObj.data.success === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    <table className="table" style={{ minWidth: "650px", marginBottom: "10px" }}>
                      <thead>
                        <tr>
                          <th style={{'width':'280px'}}>MMV <span style={{'color':'#165fbf'}}>{this.state.mmvHits[0]?.data.total}</span>  </th>
                          <th style={{'width':'200px'}}>Success</th>
                          <th style={{'width':'200px'}}>Failure</th>
                          <th style={{'width':'200px'}}>Time Out</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                      {
                          this.state.mmvHits.map((rowObj)=>{
                            if(rowObj.sourceType === 'allsource') {
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black"><strong>All Source</strong></td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td>&nbsp;</td>
                                </tr>
                              )
                            } else if(rowObj.sourceType === 'database' || 
                              rowObj.sourceType === 'suggestion') {
                              if(rowObj.data.success === 0 && rowObj.data.failure === 0 && rowObj.data.timeout === 0) {
                                return;
                              }
                              return(
                                <tr key={rowObj.sourceType}>
                                  <td className="black">{rowObj.sourceType}</td>
                                  <td>{rowObj.data.success}</td>
                                  <td>{rowObj.data.failure}</td>
                                  <td>{rowObj.data.timeout}</td>
                                  <td> &nbsp; </td>
                                </tr>
                              )
                            }
                          })
                        }
                      </tbody>
                    </table>

                    </div>
                  </div>
                </div>
              </div>

              <div className="infoTabe docInfoSec">
                <h4 className="headBg">
                  <span>Document Verification API Hits Report</span>
                  <span className="arrow" onClick={this.showDocInfoSec}><i className="fa fa-chevron-circle-down"></i></span>
                </h4>
                <div className="blockFilter form" style={this.state.docInfoSecShow ? {} : { display: 'none' }}>
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select Client</label>
                        <Select2
                          data={this.state.clientist}
                          options={{
                            placeholder: 'select client',
                          }}
                          //id="docInfoSelectClient"
                          className="form-control"
                          value={this.state.docInfoSelectClient}
                          onChange={(e) => this.setState({ docInfoSelectClient: e.target.value })}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select Plan Type</label>
                        <select id="selectApi" className="form-control" onChange={(e) => this.setState({ selectPersonalApitype: e.target.value })}>
                          <option value="all">All</option>
                          <option value="21">Pan Fetch</option>
                          <option value="26">Pan Extensive</option>
                          <option value="34">Aadhaar Fetch</option>
                          <option value="24">Aadhaar Extraction</option>
                          <option value="22">Basic Forgery</option>
                          <option value="23">Advance Forgery</option>
                          <option value="42">Aadhaar Okyc Otp</option>
                          <option value="43">Aadhaar Okyc Info</option>
                        </select>
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select Start Range</label>
                        <input className="form-control" min={this.state.backDate} value={this.state.docInfoStartDate} placeholder="Start Date" type="date"
                          onChange={(e) => this.setState({ docInfoStartDate: e.target.value })} />
                      </div>
                    </div>
                    <div className="col">
                      <div className="form-group">
                        <label className="control-title">Select End Range</label>
                        <input className="form-control" min={this.state.backDate} value={this.state.docInfoEndDate} placeholder="Start Date" type="date"
                          onChange={(e) => this.setState({ docInfoEndDate: e.target.value })} />
                      </div>
                    </div>
                    <div className="col-auto">
                      <button className="blueBtn" onClick={this.filterDocumentInfo}>Filter Now</button>
                    </div>
                  </div>
                  <div className="dasInfoTable">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>API Type</th>
                            <th>Total</th>
                            <th>Success</th>
                            <th>Failure</th>
                            <th>Time Out</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Own Database</td>
                            <td>{this.printVal(this.state.docInfoData?.databaseCounts?.total)}</td>
                            <td>{this.printVal(this.state.docInfoData?.databaseCounts?.sucess)}</td>
                            <td>--</td>
                            <td>--</td>
                          </tr>
                          <tr>
                            <td>Gamma</td>
                            <td>{this.printVal(this.state.docInfoData?.gammaCounts?.total)}</td>
                            <td>{this.printVal(this.state.docInfoData?.gammaCounts?.sucess)}</td>
                            <td>{this.printVal(this.state.docInfoData?.gammaCounts?.failure)}</td>
                            <td>{this.printVal(this.state.docInfoData?.gammaCounts?.timeOut)}</td>
                          </tr>
                          <tr>
                            <td>Delta</td>
                            <td>{this.printVal(this.state.docInfoData?.deltaCounts?.total)}</td>
                            <td>{this.printVal(this.state.docInfoData?.deltaCounts?.sucess)}</td>
                            <td>{this.printVal(this.state.docInfoData?.deltaCounts?.failure)}</td>
                            <td>{this.printVal(this.state.docInfoData?.deltaCounts?.timeOut)}</td>
                          </tr>
                          { /* <tr>
                              <td>Pan Fetch</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.ownDb)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panFetch?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Pan Extensive</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.total)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.ownDb)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.panExtensive?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Basic Forgery</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.basicForgery?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Advance Forgery</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.advanceForgery?.timeOut)}</td>
                            </tr>
                            <tr>
                              <td>Aadhaar Extraction</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.total)}</td>
                              <td>--</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.sucess)}</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.failure)}</td>
                              <td>{this.printVal(this.state.docInfoData?.aadhaarExtraction?.timeOut)}</td>
                            </tr> */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="infoTabe appInfoSec">
                <h4 className="headBg">
                  <span>RTO Mobile Application Analysis</span>
                  <span className="arrow" onClick={this.showAppInfoSec}><i className="fa fa-chevron-circle-down"></i></span>
                </h4>
                <div style={(this.state.appInfoSecShow) ? {} : { display: 'none' }}>
                  <div className="blockFilter form">
                    <div className="row">
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Select Start Range</label>
                          <input className="form-control" min={this.state.backDate} id="startDate" value={this.state.MobileAppStartDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ MobileAppStartDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group">
                          <label className="control-title">Select End Range</label>
                          <input className="form-control" min={this.state.backDate} id="endDate" value={this.state.MobileAppEndDate} placeholder="Start Date" type="date"
                            onChange={(e) => this.setState({ MobileAppEndDate: e.target.value })} />
                        </div>
                      </div>
                      <div className="col-auto">
                        <button className="blueBtn" onClick={this.filterMobileApp}>Filter Now</button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-5">
                      <ul>
                        {<li>
                          <div className="key">Total Users</div>
                          <div className="val">{this.state.userHitInfo.total_users}</div>
                          <ul>
                            <li>
                              <span className="key">Sign Up Users</span>
                              <span className="val">{this.state.userHitInfo.new_registered_user}</span>
                            </li>
                            <li>
                              <span className="key">  Logged Users </span>
                              <span className="val"> {this.state.userHitInfo.logged_users}  </span>
                            </li>


                          </ul>
                        </li>}
                        <li>
                          <div className="key">Total Leads</div>
                          <div className="val">{this.state.mobileApplication.TotalLeads}</div>

                          <ul>

                            {this.state.leadReport.length <= 0 ? <li><b><center>{this.state.DataNotFound}</center></b></li> : this.state.leadReport.map(list => {
                              return (
                                <li>
                                  <span className="key">{list.reportName}</span>
                                  <span className="val">{list.reportValue}</span>
                                </li>
                              )
                            })}
                          </ul>
                        </li>
                      </ul>
                    </div>
                    <div className="col-md-7">
                      <div className="dasInfoTable">
                        <div className="table-responsive">
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                                <th>&nbsp;</th>
                                <th>All Hits</th>
                                <th>Success </th>
                                <th>Not Found </th>
                                <th>Failure</th>
                                <th>Time Out</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td className="black">Challan</td>
                                <td>{this.state.challanApiHitInfo.total}</td>
                                <td>{this.state.challanApiHitInfo.suc_owndb}</td>
                                <td>{this.state.challanApiHitInfo.notfound_gama}</td>
                                <td>{this.state.challanApiHitInfo.fail}</td>
                                <td>{this.state.challanApiHitInfo.timeout}</td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                        <br />
                        <div className="table-responsive">
                          <table className="table" style={{ minWidth: "600px", marginBottom: "10px" }}>
                            <thead>
                              <tr>
                                <th>&nbsp;</th>
                                <th>Success</th>
                                <th>Failure</th>
                                <th>Total</th>
                              </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td className="black">Rc Prime</td>
                              <td>{this.state.rcPrimeHitInfo.rc_success}</td>
                              <td>{this.state.rcPrimeHitInfo.rc_failure}</td>
                              <td>{this.state.rcPrimeHitInfo.rc_total}</td>
                            </tr>
                            <tr>
                              <td className="black">Service History</td>
                              <td>{this.state.serviceHitInfo.service_success}</td>
                              <td>{this.state.serviceHitInfo.service_failure}</td>
                              <td>{this.state.serviceHitInfo.service_total}</td>
                            </tr>
                            <tr>
                              <td className="black">Total</td>
                              <td>{this.state.totalHitInfo.total_success}</td>
                              <td>{this.state.totalHitInfo.total_failure}</td>
                              <td>{this.state.totalHitInfo.total_hits}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loader" style={{ display: "none" }}>
            <div className="bg"></div>
            <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }
  }
}

export default Dashboard;
